export type SortDir = 'asc' | 'desc';

// Returns a comparator that sorts by the value returned from getValue, honoring dir.
export function compareBy<T>(
  getValue: (item: T) => string | number,
  dir: SortDir,
): (a: T, b: T) => number {
  return (a, b) => {
    const av = getValue(a);
    const bv = getValue(b);
    // Strings: case-insensitive, locale-aware (also sorts numeric-in-string naturally).
    if (typeof av === 'string' && typeof bv === 'string') {
      const cmp = av.localeCompare(bv, undefined, { sensitivity: 'base', numeric: true });
      return dir === 'asc' ? cmp : -cmp;
    }
    if (av < bv) return dir === 'asc' ? -1 : 1;
    if (av > bv) return dir === 'asc' ? 1 : -1;
    return 0;
  };
}
